
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
const MultiSelectInput = forwardRef(({ isInviting, onItemAdded, placeholder, onKeyPressed, sendError, collectionUpdated }, ref) => {


	const inputRef = useRef(null);
	const [values, setValues] = useState([]);
	const [text, setText] = useState([]);
	const [error, setError] = useState();

	useImperativeHandle(ref, () => ({
		addItem(val) {
			setValues([...values, val]);
			collectionUpdated([...values, val]);
			setText("");
		},
	}));

	const handleKeyUp = (e, bypass) => {
		const email = text.length === 0 ? "": text.trim()
		if (e.key === "Enter" || bypass) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (re.test(String(email).toLowerCase())) {
				if (values.indexOf(email) === -1) {
					onItemAdded(email);
				} else {
					setError(`${email} is already added!`);
					sendError(`${email} is already added!`);
				}
			} else {
				if ((email && email.length === 0) || e.key === undefined) {
					setError("")
					sendError("")
				} else if (email !== "") {
					setError("Email address is not valid!");
					sendError("Email address is not valid!");
				}
			}
			if (!bypass) e.preventDefault();
		}
	};

	useEffect(() => {
		inputRef.current && inputRef.current.focus();
	}, []);

	return (
		<div className="flex-wrap d-flex">
			<div className={isInviting ? "w-100" : "disabled-input-wrapper w-100"} >
				<input
					placeholder={values.length > 49 ? 'Max 50 user invitations is allowed!' : placeholder}
					ref={inputRef}
					type="text"
					className={`mb-1 form-control big-control ${error && "is-invalid"}`}
					value={text}
					disabled={values.length > 49}
					onKeyUp={handleKeyUp}
					onBlur={() => {
						handleKeyUp({ key: "Enter" }, true);
					}}
					onChange={(e) => {
						setText(e.target.value);
						setError("");
						sendError("");
						onKeyPressed();
					}}
				/>
			</div>


			{
				values.length > 0 &&
				values.map((o, i) => (
					<div className="m-2 ms-0 rounded d-center bg-tag d-inline-block" key={i}>
						<span className="ms-2">{o}</span>
						<i
							className="p-1 m-1 fa fa-times border-start pointer"
							onClick={() => {
								setValues(values.filter((o, ind) => ind !== i));
								collectionUpdated(values.filter((o, ind) => ind !== i));
							}}
						></i>
					</div>
				))
			}

		</div >
	);
});

export default MultiSelectInput;
